import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";
import {
    type IBannerAlertProps,
    type IHeaderAlertExtraData,
} from "commonComponents/utilities/HeaderAlerter/HeaderAlerter.types";

export type IAccountingOutageBannerProps = IBannerAlertProps<IHeaderAlertExtraData | undefined>;

/**
 * Tells users that QuickBooks Online itself may be down, so they can tell an Intuit outage from a
 * broken account.
 *
 * Deliberately has no action button: nobody can fix an Intuit outage, and every action we could offer
 * (reconnect, contact Support) would send the user somewhere that cannot help. The copy is set
 * backend-side where the `SystemAlert` is built, so this renders whatever the alert carries.
 */
const AccountingOutageBannerInternal: React.FunctionComponent<IAccountingOutageBannerProps> = ({
    alert,
}) => {
    return (
        <BTAlert
            title={alert.alertTitle}
            message={alert.alertText}
            type="warning"
            data-testid="accountingOutage"
            banner
        />
    );
};

const AccountingOutageBanner = withErrorBoundary(AccountingOutageBannerInternal)(
    "Could not load Accounting Outage Banner",
);

export default AccountingOutageBanner;
